/**
 * Decode a Google encoded polyline (precision 5) into { latitude, longitude } points.
 */
export const decodePolyline = (encoded) => {
  const points = [];
  let index = 0;
  let lat = 0;
  let lng = 0;
  while (index < encoded.length) {
    let result = 0;
    let shift = 0;
    let byte;
    do {
      byte = encoded.charCodeAt(index) - 63;
      index += 1;
      result += (byte & 0x1f) * (2 ** shift);
      shift += 5;
    } while (byte >= 0x20);
    lat += result % 2 === 1 ? -(result + 1) / 2 : result / 2;

    result = 0;
    shift = 0;
    do {
      byte = encoded.charCodeAt(index) - 63;
      index += 1;
      result += (byte & 0x1f) * (2 ** shift);
      shift += 5;
    } while (byte >= 0x20);
    lng += result % 2 === 1 ? -(result + 1) / 2 : result / 2;

    points.push({ latitude: lat / 1e5, longitude: lng / 1e5 });
  }
  return points;
};
